/** Files: Local (the built-in file system) · OneDrive · Google Drive.
 *  Cloud tabs are only shown to owners / admins / superadmins. */
import { useState } from "react";
import { HardDrive, Cloud } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import FilesTab from "./FilesTab";
import CloudDriveTab from "./CloudDriveTab";

const TABS = [
  { key: "local", label: "Local", icon: HardDrive },
  { key: "onedrive", label: "OneDrive", icon: Cloud },
  { key: "google", label: "Google Drive", icon: Cloud },
];

export default function FilesHub() {
  const { user } = useAuth();
  const canCloud = ["owner", "admin", "superadmin"].includes(user?.role);
  const initial = new URLSearchParams(window.location.search).get("cloud");
  const [tab, setTab] = useState(canCloud && ["onedrive", "google"].includes(initial) ? initial : "local");
  if (!canCloud) return <FilesTab />;
  return (
    <div className="space-y-3" data-testid="files-hub">
      <div className="flex w-fit gap-1 rounded-full border border-white/10 bg-white/5 p-0.5 text-[11px] font-semibold" data-testid="files-hub-tabs">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button key={key} onClick={() => setTab(key)} className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 ${tab === key ? "bg-[#1a3fd1] text-white" : "text-white/60 hover:text-white"}`} data-testid={`files-hub-tab-${key}`}>
            <Icon className="h-3.5 w-3.5" /> {label}
          </button>
        ))}
      </div>
      {tab === "local" ? <FilesTab /> : <CloudDriveTab key={tab} provider={tab} />}
    </div>
  );
}
